// extracted by mini-css-extract-plugin
export default {"alertContent":"styles_alert-content_SwNGk","closeButton":"styles_close-button_ZBB1Q"};